export default {
	"sendGoods": {
		"printStockList": "打印备货清单",
		"sendGoodsHandle": "发货",
		"andSelfNo": "自提单号",
		"subSelfNo": "取消自提",
		"tips": "此派车单中存在重复标签必须选择中转单号才能进行发货",
		"cancelSendGoods": "取消发货",
		"deliverNo": "发货单",
		"sendGoodsDialog": "发货信息",
		"tagAnomalyDialog": "标签发货异常信息",
		"andSelfDialog": "追加自提单",
		"transferBillList": "中转单列表",
		"deliveryName": "发货操作人",
		"deliveryTime": "发货操作时间",
		"cancelTransferBill": "是否确认取消此中转单？",
		"validataTips1": "请输入实发包装数！",
		"validataTips2": "请输入破损包装数！",
		"validataTips3": "取消发货成功！",
		"validataTips4": "取消发货失败！",
		"validataTips5": "请选择相同的中转单号补打标签！"
	},
	"transferDelivery": {
		"sendGoods": "发货",
		"sendGoodsCompleteTime": "发货完成时间",
		"sendGoodsComplete": "发货完成",
		"downloadDeliverNo": "打印发货单",
		"deliveredContainerQty": "容器标签数",
		"transferNums": "单数",
		"deliveredPackingQty": "包装标签数",
		"transferBillInfo": "中转单信息",
		"losePackingDialogTitile": "缺失包装信息",
		"startDeliveryDt": "开始发货时间",
		"dispatchingDt": "调度时间",
		"fileNum": "随附单",
		"Tips1": "未扫描到的包裹如下",
		"Tips2": "请确认列表中的包装是否丢失？",
		"identification": "司机证件号"
	},
	"transferList": {
		"appointmentHandle": "自提预约",
		"expectedReceiveTime": "计划收货时间",
		"actualReceiveTime": "实际收货时间",
		"expectedDeliveryTime": "计划发货时间",
		"actualDeliveryTime": "实际发货时间",
		"affixedCodeType": "贴码方式",
		"receiveRouteNo": "收货派车单号",
		"receiveTransportNo": "收货运单号",
		"deliveryTransportNo": "发货运单号",
		"deliveryRouteNo": "发货派车单号",
		"planDeliveryDt": "预约发货时间",
		"planReceiveDt": "预约收货时间",
		"receiveDispatcherName": "收货调度人",
		"receiveComplete": "收货完成",
		"packingContainer": "打印容器标签",
		"collectGoods": "收货",
		"filesManageShowHide": "随附单附件",
		"acPacking": "实收/应收包装数",
		"receivedGoodsTemperature": "收货货温℃",
		"patchLabel": "补打标签",
		"labelNo": "标签号",
		"labelType": "标签类型",
		"printPackingTag": "打印包装标签",
		"storePlace": "存放位置",
		"tagNumber": "标签数量",
		"storeReceivePlace": "收货存放位置",
		"containNum": "容器内包装数",
		"number": "容器数",
		"source": "标签源",
		"scaned": "已扫描",
		"goodsInfoDialog": "收发货信息",
		"tag": "标签",
		"damagedPackingQty": "损坏包装数",
		"tips1": "此标签为已收货状态才能修改信息",
		"tips2": "此标签已经收货，可以再修改信息后点击【提交】",
		"tagTitle": "标签收货异常信息",
		"reason": "原因",
		"copyAll": "复制所有信息",
		"appointmentTitle": "自提信息",
		"mapTracking": "地图跟踪",
		"distance": "现在距离",
		"deliveryBillTypeStr": "发货单类型",
		"tempControlName": "温度类型",
		"validataTips1": "请输入存放位置！",
		"validataTips2": "请选择标签源！",
		"validataTips3": "请输入标签号！",
		"receiveSuccess": "收货成功!",
		"validataTips4": "请输入容器数！",
		"validataTips5": "请输入容器内包装数！",
		"validataTips6": "请输入标签数量！",
		"validataTips7": "勾选数据必须都是已收货状态！",
		"validataTips8": "确定要重收操作吗",
		"validataTips9": "重收成功！",
		"validataTips10": "重收失败！",
		"validataTips11": "勾选数据不能是'已发货'状态！",
		"validataTips12": "确定要作废操作吗",
		"validataTips13": "收货货温请输入-100到100之间的数字",
		"validataTips14": "请选择未生成中转发货单的中转单！",
		"validataTips15": "请选择中转单状态为'待收货'或'已收货'的中转单",
		"validataTips16": "所有中转单的站点必须相同!",
		"validataTips17": "所有中转单必须是同一个货主!",
		"validataTips18": "请选择计划发货时间区间！",
		"validataTips19": "自提预约成功！"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/transfer/transfer.js